import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import {
  HeaderLink,
  Subtitle,
  LinkGroup,
  SubtextLink
} from 'Styles/links';
import LinkText from '../../../LinkText/LinkText';

const NavigationSection = ({ item }) => {
  const router = useRouter();

  const handleLinkClick = (e) => {
    e.preventDefault();
    const path = e.currentTarget.getAttribute('href');
    if (path) router.push(path);
  };

  return (
    <>
      {item.content.text && (
        <HeaderLink
          href={item.content.url}
          onClick={handleLinkClick}
          variant='title'
          data-label="navLink_L2"
        >
          {item.content.text}
        </HeaderLink>
      )}
      {item.content.subtext && (
        <SubtextLink
          href={item.content.url}
          size="X-Mini"
          variant='title'
          onClick={handleLinkClick}
          data-label="navLink_L2"
        >
          {item.content.subtext}
        </SubtextLink>
      )}
      {item.content.sections
        .filter((level3Section) => !level3Section.hideOnDesktop)
        .map((level3Section) => (
          <React.Fragment key={level3Section.id}>
            {level3Section.text && (
              <Subtitle variant="mini">{level3Section.text}</Subtitle>
            )}
            {level3Section.links && (
              <LinkGroup variant="mini" paddingSize="md">
                {level3Section.links
                  .filter(
                    (level3SectionLink) => !level3SectionLink.hideOnDesktop
                  )
                  .map((level3SectionLink) => (
                    <LinkText
                      as={
                        level3SectionLink.url &&
                        !level3SectionLink.url.includes('/help')
                          ? NextLink
                          : LinkText
                      }
                      href={level3SectionLink.url}
                      size='Mini'
                      data-label="navLink_L3"
                      key={level3SectionLink.id}
                    >
                      {level3SectionLink.text}
                    </LinkText>
                  ))}
              </LinkGroup>
            )}
          </React.Fragment>
        ))}
    </>
  );
};

NavigationSection.propTypes = {
  item: PropTypes.shape({
    content: PropTypes.shape({
      text: PropTypes.string,
      subtext: PropTypes.string,
      url: PropTypes.string,
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          hideOnDesktop: PropTypes.bool,
          links: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              url: PropTypes.string,
              text: PropTypes.string
            })
          )
        })
      )
    })
  }).isRequired
};

export default NavigationSection;
